import React from 'react'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import color from 'color'
import classNames from 'classnames'

const styles = theme => ({
  button: {
    backgroundColor: theme.colors.primary,
    color: color(theme.colors.primary).isLight() ? '#000' : '#fff',
    border: 0,
    boxShadow: {
      x: -theme.base.shadowLength / 2,
      y: theme.base.shadowLength / 2,
      color: theme.colors.shadow
    },
    textAlign: 'center',
    '&:focus': {
      outlineColor: color(theme.colors.primary).darken(0.5).alpha(0.5).toString()
    },
    '&:active': {
      backgroundColor: theme.colors.primaryDark,
    }
  },
  block: {
    display: 'block',
    width: '100%',
  },
})

const Button = ({ classes, children, block, theme, ...props }) => (
  <button {...props} className={classNames(classes.button, { [classes.block]: block })}>{children}</button>
)

Button.propTypes = {
  block: PropTypes.bool
}

export default injectSheet(styles)(Button)
